import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black/60 z-[100] flex items-center justify-center pointer-events-none"
}
const _hoisted_2 = { class: "bg-[#141a24] border border-gray-700 rounded-lg px-6 py-4 flex items-center gap-3 shadow-2xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-sm" }, "Chargement de l'agence…", -1)

import { menu, routing } from "@/services";
import { currentStation, getAllStationsUser, isStationSwitching, userInfos, userStats } from "@/state/api/userState";
import { useStationsStore } from "@/stores/stations.store";
import { detectPlatform, getDeviceType, getSearchParam } from "@/utils";
import { storeToRefs } from "pinia";
import { onBeforeMount, onBeforeUnmount, onMounted, provide, ref, Ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Background from "./components/widgets/Background.vue";
import BackgroundWorkspace from "./components/widgets/BackgroundWorkspace.vue";
import useAccess from "./composable/useAccess";
import { authRoutes, dashboardRoutes } from "./router/helper";
import { currentStationIDSession } from "./state/services/sessionState";

	/**
	 * Variables
	 */

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const router = useRouter();
	// const route:any = useRouteStore().currentRoute;
	const route = useRoute();

	const platform = detectPlatform();

	const store = useStationsStore();
	const { stations } = storeToRefs(store) as { stations: Ref<any> };

	let deviceType = ref<any>(getDeviceType());

	// Listener nommé → cleanup possible. Avant : closure inline sans
	// removeEventListener au unmount → leak mémoire (et duplication
	// si App.vue était re-monté, ce qui n'arrive pas en pratique mais
	// reste un anti-pattern).
	const onResize = () => {
		deviceType.value = getDeviceType();
	};
	window.addEventListener("resize", onResize);
	onBeforeUnmount(() => {
		window.removeEventListener("resize", onResize);
	});

	watch(() => userInfos.value, async () => {
			await getAllStations();
	});

	watch(() => route.name, async () => {
		await setupCurrentStation();
	});

	watch(() => route.path, () => {
		menu.findActive(route);
		}, {immediate: true,}
	);

	const setupCurrentStation = async () => {
		await getAllStations();

		return new Promise((resolve) => {
			// L'agence persistée (localStorage "crtstn_id") est relue À CHAQUE
			// appel : avant, `currentStationIDSessionExists` était une constante
			// figée à l'import (crtstn_id valait 0 → false pour toute la session),
			// donc chaque navigation réécrasait l'agence choisie par la première
			// station (stations[0]). On lit la valeur vivante ici.
			const sid = Number(currentStationIDSession.value);
			const hasSessionStation = sid !== 0 && sid !== -1;

			// Une agence nommée dans l'URL (`?station=`) PRIME sur l'agence
			// persistée : c'est un lien profond volontaire (partage d'écran,
			// favori, retour arrière). Sans cette priorité, ouvrir
			// `…/expedition?station=18` affichait l'agence de la session
			// précédente — l'URL disait 18, l'écran montrait 19, et le
			// changement d'agence semblait ne pas suivre.
			//
			// L'appartenance est vérifiée : un `?station=` bricolé à la main
			// vers une agence qui n'est pas la sienne est ignoré.
			const urlSid = Number(route.query.station ?? 0);
			const urlStation =
				urlSid && useAccess('stationBelongTo', [String(urlSid)])
					? stations?.value.find((station: any) => station.key == urlSid)
					: undefined;

			const persistedStation = () =>
				urlStation
					?? (hasSessionStation && useAccess('stationBelongTo', [String(sid)])
						? stations?.value.find((station: any) => station.key == sid)
						: stations?.value[0]);

			if (dashboardRoutes.every(r => r == route.name) && stations.value.length >= 2) {
				currentStation.value = persistedStation();
			} else if (stations.value?.length !== 0) { // ici, la vue d'ensemble n'est pas incluse
				currentStation.value = persistedStation();
			}

			resolve(true)
		})
	}

	async function getAllStations(dashboardRoutes_ = dashboardRoutes) {

		return new Promise((resolve) => {

			if (route.name && !authRoutes.includes(route.name as string)) {
				if (route.name && dashboardRoutes_.every(r => r == route.name) && useAccess('visibility', ['Admin', 'CoAdmin'])) {
					// Vue d'ensemble incluse uniquement pour les admins et co-admins
					getAllStationsUser({ strictMode: false }).then(r => {
						stations.value = r
					});
				} else {
					getAllStationsUser().then(r => {
						stations.value = r
					});
				}

			} else { stations.value = [] }
			// console.log('stations.valeeeue: ', stations.value);
		resolve(true)
		})
	}

	const particlesLoaded = async (container:any) => {
    console.log("Particles container loaded", container);
	};

	/**
	 * App Lifecycle
	 */
	onBeforeMount(async () => {

		// await setupCurrentStation();
	});

	onMounted(async () => {
		// console.log("route store", route, route.name);
	// await setupCurrentStation();
	})

	/**
	 * Providers
	 */
	provide("platform", platform);
	provide("deviceType", deviceType);

	// App menu
	provide("navigations", routing.navigations);
	provide("subNavigations", menu.subNavigations);
	provide("activeWorkspace", menu.activeWorkspace);

	// User infos
	provide("userStats", userStats);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(route).matched[0]?.name == 'auth' || _unref(route).matched[0]?.name == 'error')
      ? (_openBlock(), _createBlock(Background, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_RouterView, null, {
              default: _withCtx(({ Component }) => [
                _createVNode(_Transition, { name: "fade-slow" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(BackgroundWorkspace, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_RouterView, null, {
              default: _withCtx(({ Component }) => [
                _createVNode(_Transition, { name: "fade-slow" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_ConfirmModal),
    _createVNode(_Transition, { name: "fade-slow" }, {
      default: _withCtx(() => [
        (_unref(isStationSwitching))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Spinner, { color: "#25e0d0" }),
                _hoisted_3
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})